import { ProjectSiteStatus_Enum as SiteStatus } from '@paramount-prestart/shared'

const _siteStatus = {}
_siteStatus[SiteStatus.ONGOING] = 'On Going'
_siteStatus[SiteStatus.ON_HOLD] = 'On Hold'
_siteStatus[SiteStatus.COMPLETED] = 'Completed'
export const siteStatus = _siteStatus

// Valid status changes the user can make from the current status. Mirrors the
// server-enforced rules in @paramount-prestart/shared so the UI only offers
// legal transitions (Completed is terminal — returns []).
export const nextStatusOptions = (currentStatus) =>
  (SiteStatus.ALLOWED_TRANSITIONS[currentStatus] || []).map((value) => ({
    value,
    label: siteStatus[value],
  }))

// Action-oriented labels for each transition button (what the click *does*).
const _statusActionLabel = {}
_statusActionLabel[SiteStatus.ONGOING] = 'Resume'
_statusActionLabel[SiteStatus.ON_HOLD] = 'Put On Hold'
_statusActionLabel[SiteStatus.COMPLETED] = 'Mark Complete'
export const statusActionLabel = _statusActionLabel

export const GROUP_BY_MONTH = 'month'

export const groupByOptions = [
  { value: GROUP_BY_MONTH, label: 'Month & Year' },
]
